export default function MySQL_TIME_FORMAT() {
  return (
    <div>
      <h2>MySQL_TIME_FORMAT</h2>    </div>
  );
}